/**
 * The distance between the adjacent edges of the stack's elements.
 */
export var StackSpacing = {
  ExtraLoose: 'extraLoose',
  Loose: 'loose',
  None: 'none',
  Tight: 'tight',
  ExtraTight: 'extraTight'
};